import React from "react";
import "./CheckboxCustom.scss";
import { Form, Checkbox } from "antd";

const CheckboxCustom: React.FC<any> = ({headingleft, name, rules, rtl}) => {
    return (
        <div className={`mb-3`}>
            <Form.Item
                name={name}
                rules={rules}
                help={false}
                valuePropName="checked"
            >
                <Checkbox className={`custom-checkbox ${rtl ? 'text-right' : ''}`}>{headingleft}</Checkbox>
            </Form.Item>
        </div>
    )
}

export default CheckboxCustom;
